import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Intervention } from "../domain/intervention";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { DisponibiliteClientDTO } from "./DTO/disponibilite.dto";

@Injectable({
    providedIn: 'root',
})
export class InterventionService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/intervention`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    // makeOrder(intervention: Intervention, mList, strategyId: number) {

    //     const body: any = Object.assign({}, intervention);
    //     body.ClientMeasures = mList;
    //     this.loadingTask.activateLoading();
    //     return this.http.post(`${this.serviceUrl}/${strategyId}`, JSON.stringify(body), this.generateHeader()).pipe(
    //         catchError(this.handleError<any>('makeOrder')),
    //         finalize(() => this.loadingTask.deactivateLoading()),
    //         map((response: boolean) => {
    //             return response;
    //         }));
    // }

    updateOrder(intervention: Intervention, mList) {

        const body: any = Object.assign({}, intervention);
        body.ClientMeasures = mList;
        const dc = new DisponibiliteClientDTO();
        if (intervention.DisponibiliteClientList[0].From) {
            dc.From = new Date(intervention.DisponibiliteClientList[0].From.getTime() - (intervention.DisponibiliteClientList[0].From.getTimezoneOffset() * 60000)).toJSON()
            dc.To = new Date(intervention.DisponibiliteClientList[0].To.getTime() - (intervention.DisponibiliteClientList[0].To.getTimezoneOffset() * 60000)).toJSON()
        }
        body.DisponibiliteClientList = [dc]
        body.LingetteAreaMapTerrainList = undefined;
        body.MassifAreaMapTerrainList = undefined;
        this.loadingTask.activateLoading();
        return this.http.request(new HttpRequest('PUT', `${this.serviceUrl}`, JSON.stringify(body), this.generateHeader()))
            .pipe(
                catchError(this.handleError<any>('createDocument')),
                finalize(() => this.loadingTask.deactivateLoading()));
        // .pipe(
        //     catchError(this.handleError<any>('updateOrder')),
        //     finalize(() => this.loadingTask.deactivateLoading()),
        //     map((response: boolean) => {
        //         return response;
        //     }));

    }

    getInterventionNewed() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/my/new`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getInterventionNewed')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Intervention[]) => {
                return response.map((item: Intervention) => {
                    return Intervention.mapFromJSON(item);
                });
            }));
    }

    getInterventionInPending() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/my/pending`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getInterventionInPending')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Intervention[]) => {
                return response.map((item: Intervention) => {
                    return Intervention.mapFromJSON(item);
                });
            }));
    }

    getInterventionInProgress() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/my/inprogress`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getInterventionInProgress')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Intervention[]) => {
                return response.map((item: Intervention) => {
                    return Intervention.mapFromJSON(item);
                });
            }));
    }

    getInterventionCanceled() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/my/canceled`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getInterventionCanceled')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Intervention[]) => {
                return response.map((item: Intervention) => {
                    return Intervention.mapFromJSON(item);
                });
            }));
    }

    getInterventionById(id: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${id}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getInterventionById')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Intervention) => {
                return Intervention.mapFromJSON(response);
            }));
    }

    getInterventionByStrategyId(id: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/strategy/${id}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getInterventionByStrategyId')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Intervention[]) => {
                return response.map((item: Intervention) => {
                    return Intervention.mapFromJSON(item);
                });
            }));
    }

    deleteIntervention(id: number, justification: string) {
        this.loadingTask.activateLoading();
        const dto = { reason: justification }
        return this.http.put(`${this.serviceUrl}/${id}`, JSON.stringify(dto), this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteIntervention')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}